import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { ApplicationDetail } from '../../models/classes/ApplicationDetail.class'
import { BASEURL_POLYMER, SUB_PATH_BASIC } from '../../utils/api'
interface QueryParams {
  application_id: string
  uinfin: string
  singpass_token: string

}
export const stagesApplicationApi = createApi({
  reducerPath: 'stagesApplicationApi',
  baseQuery: fetchBaseQuery({ baseUrl: BASEURL_POLYMER, 
  prepareHeaders:(headers,{getState})=>{
    headers.set("Access-Control-Request-Method", "GET");
    headers.set("X-Content-Type-Options", "nosniff");
  } }),
  endpoints: (builder) => ({
    getStagesApplication: builder.query<ApplicationDetail, QueryParams>({
      query: (queryParams: QueryParams) => ({
        method: "GET",
        url:`${SUB_PATH_BASIC}/getApplicationStages/${queryParams.application_id}`, 
        headers: {
          uinfin: queryParams.uinfin,
          Authorization: `Bearer ${queryParams.singpass_token}`
        },
      }),
      keepUnusedDataFor:1,
    }),
  }),
})

export const { useGetStagesApplicationQuery } = stagesApplicationApi

